import Endpoints from 'constants/Endpoints';
import {RestRequestGET, RestRequestPOST} from 'libs/RestRequest';
import {clearResource, setResource} from 'redux/actions'
import reduxStore from 'redux/store'

export const RESOURCE_ID = 'rfxSupplier';

export const clearSuppliers = () => {
    reduxStore.dispatch(clearResource(RESOURCE_ID));
}
export const getSuppliers = async (demandId, roundId, pagination ) => {

    const params = {
        ...pagination
    }

    try {

        const res = await RestRequestGET(Endpoints.SUPPLIERS_LIST(demandId, roundId), {params});

        if (pagination.page > 1) {
            const state = reduxStore.getState();
            if (state?.resources?.rfxSupplier) {
                const res2 = {
                    ...res,
                    items: [...state.resources.rfxSupplier.items, ...res.items],
                }
                reduxStore.dispatch(setResource(RESOURCE_ID, res2));
                return;
            }
        }
        reduxStore.dispatch(setResource(RESOURCE_ID, res));

    } catch (error) {
    }
}

const add = async (demandId, roundId, values) => {
    try {
        return await RestRequestPOST(Endpoints.SUPPLIERS_ADD(demandId, roundId), values)
    } catch (error) {
    }
}

const invite = async (demandId, roundId, values) => {
    try {
        return await RestRequestPOST(Endpoints.SUPPLIERS_INVITE(demandId, roundId), values)
    } catch (error) {
    }
}

const changeExternalSign = async (demandId, roundId, supplierId) => {
    try {
        const res = await RestRequestPOST(Endpoints.SUPPLIERS_CHANGE_EXTERNAL_SIGN(demandId, roundId, supplierId));
        const state = reduxStore.getState();
        if (state?.resources?.rfxSupplier && res !== null) {
            const suppliers = state.resources.rfxSupplier;
            const suppliers2 = {
                ...suppliers,
                items: suppliers.items.map((item) => item.id === res.id ? res : item)
            }
            reduxStore.dispatch(setResource(RESOURCE_ID, suppliers2));
        }
        return res;
    } catch (error) {
    }
}

export default {
    invite,
    add,
    getSuppliers,
    clearSuppliers,
    changeExternalSign,
    RESOURCE_ID
}